module.exports = __webpack_public_path__ + "img/PNCBank.668147aa.svg";